export const LTLRoute = {
  path: '/ltl',
  load: () => import('./LTL'),
  protected: true,
};

export const SavedQuoteRoute = {
  path: '/savedQuotes',
  load: () => import('./SavedQuotes'),
  protected: true,
};

export * from './constants';
